import { guestRoutes } from './guest-routes'
import {
  NavigationGuardNext,
  RouteLocationNormalized,
  createRouter,
  createWebHistory,
} from 'vue-router'

import { usePostHog } from '@/common/composables/usePostHog'
import { useSettingStore } from '@/stores/setting'

function beforeEach(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  const { capturePageleave } = usePostHog()
  capturePageleave(from)

  if ('vite' in from.query && !('vite' in to.query)) {
    return next({
      ...to,
      query: { ...to.query, vite: from.query.vite },
    })
  }

  next()
}

async function afterEach(to: RouteLocationNormalized) {
  const settingStore = useSettingStore()
  const { capturePageview, group } = usePostHog()
  capturePageview(to)
  group({
    slug: settingStore.venue_slug,
    name: settingStore.venue_name,
    id: settingStore.venue_id,
  })
  document.title = <string>to.meta.pageTitle || settingStore.venue_name
}

export function mkGuestRouter() {
  const router = createRouter({
    routes: guestRoutes,
    history: createWebHistory(),
  })
  router.beforeEach(beforeEach)
  router.afterEach(afterEach)
  return router
}
